import { URI_REPORT } from '@/config/config';

export default async ({ rootState }) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
    body: null,
  };

  const userLoginInfoResult = await fetch(`${URI_REPORT}dashboard/notify-count`, opts);
  return userLoginInfoResult.json();
};
